import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ValidatorForm } from 'react-material-ui-form-validator';

import {
	withStyles,
	withWidth,
	Grid,
	Typography,
	Button,
	TextField,
	Divider,
	RootRef,
	Tooltip
} from '@material-ui/core';

import Constants from "../utils/Constants";
import FormHelper from "../utils/FormHelper";
import ResponsiveDialog from "./ResponsiveDialog";
import LabeledCheckbox from "./LabeledCheckbox";

const styles = theme => ({
	dlgPaper: {
		minWidth: 325
	},

	button: {
		"@media (hover: none)": {
			"&:hover": {
				backgroundColor: theme.palette.primary.main
			}
		}
	},

	buttonGrid: {
		marginTop: theme.spacing(2)
	},

	noteFieldRoot: {
		fontSize: "1rem"
	},

	noteField: {
		width: "100%",
		color: theme.palette.primary.darkGrey,
		borderRadius: theme.spacing(2.5),
		backgroundColor: theme.palette.primary.grey,

		"& input": {
			padding: "9px 12px"
		}
	},

	saveBtn: {
		whiteSpace: "nowrap"
	},

	noThxBtnItem: {
		paddingRight: theme.spacing(1)
	},

	questionItem: {
		paddingBottom: theme.spacing(4)
	},

	subtitle: {
		paddingBottom: theme.spacing(4)
	},

	dlgTitle: {
		paddingBottom: 0
	},

	suppressForm: {
		paddingLeft: theme.spacing(0.5)
	},

	suppressRateChkBx: {
		marginRight: 0
	},

	suppressRateTooltip: {
		maxWidth: 180
	}
});

class RateAlertDialog extends Component {
	constructor(props, context) {
		super(props, context);

		this.dialog = React.createRef();
		this.state = this.initialState;

		if (props.suppressRate) {
			this.state.suppressRate = true;
		}

		this.rateValue = this.rateValue.bind(this);
		this.noteChanged = this.noteChanged.bind(this);
		this.saveClicked = this.saveClicked.bind(this);
		this.onEntering = this.onEntering.bind(this);
		this.suppressRateClicked = this.suppressRateClicked.bind(this);
		this.nextStep = this.nextStep.bind(this);

		if (props.hasCareFeature) {
			this.careStatus = this.careStatus.bind(this);
		}

	}

	get initialState() {
		return {
			valuable: null,
			comments: null,
			careStatus: null,
			suppressRate: false
		};
	}

	componentDidMount() {
		this.setState(this.props.rating);
	}

	onEntering() {
		let {rating} = this.props;

		if (rating.id == null) {
			Object.assign(rating, this.initialState, {suppressRate: this.state.suppressRate});
		}

		this.setState(rating);
	}

	rateValue(rating) {
		this.setState({valuable: rating});
	}

	noteChanged(ev) {
		this.setState({comments: ev.target.value});
	}

	suppressRateClicked(event) {
		let changes = FormHelper.getChanged(event);
		this.setState(changes, () => this.props.suppressRateHandler(changes.suppressRate));
	}

	careStatus(status) {
		this.setState({careStatus: status});
	}

	saveClicked() {
		let {rateHandler, closeHandler} = this.props;
		rateHandler(this.state);
		this.nextStep();
		closeHandler();
	}

	nextStep() {
		let {nextStepHandler, hasCareFeature} = this.props;
		if (hasCareFeature) {
			let {careStatus} = this.state;
			let {careStatusHandler, activityId} = this.props;
			if(careStatus === Constants.ACTIVITY.CARE_STATUSES.RESOLVED.ID) {
				careStatusHandler(activityId, careStatus, '');
			}
		}
		if (nextStepHandler) {
			nextStepHandler();
		}
	}

	render() {
		let {valuable, comments, careStatus} = this.state,
			{classes, open, width, closeHandler, showSubtitle, nextStepHandler, hasSuppressFeature, hasCareFeature} = this.props,
			smaller = width.includes("sm") || width.includes("xs"),
			content = (
				<RootRef rootRef={this.dialog}>
					<React.Fragment>
						{showSubtitle ? <Typography className={classes.subtitle}>{Constants.ACTIVITY.ACTION_BUTTONS.getRate().tooltip}</Typography> : null}
						<Grid container direction="column" justify="space-between">
							<Grid item className={classes.questionItem}>
								<Typography className={classes.question}>Was this a valuable alert?</Typography>
								<Grid container justify="space-around" className={classes.buttonGrid}>
									<Grid item>
										<Button
											onClick={() => this.rateValue(Constants.ACTIVITY.RATINGS.YES)}
											className={classes.button}
											variant={valuable === Constants.ACTIVITY.RATINGS.YES ? "contained" : "outlined"}
											color={valuable === Constants.ACTIVITY.RATINGS.YES ? "primary" : "default"}>
											Yes
										</Button>
									</Grid>
									<Grid item>
										<Button
											onClick={() => this.rateValue(Constants.ACTIVITY.RATINGS.NO)}
											className={classes.button}
											variant={valuable === Constants.ACTIVITY.RATINGS.NO ? "contained" : "outlined"}
											color={valuable === Constants.ACTIVITY.RATINGS.NO ? "primary" : "default"}>
											No
										</Button>
									</Grid>
									<Grid item>
										<Button
											onClick={() => this.rateValue(Constants.ACTIVITY.RATINGS.MAYBE)}
											className={classes.button}
											variant={valuable === Constants.ACTIVITY.RATINGS.MAYBE ? "contained" : "outlined"}
											color={valuable === Constants.ACTIVITY.RATINGS.MAYBE ? "primary" : "default"}>
											Unsure
										</Button>
									</Grid>
								</Grid>
							</Grid>
							
							{hasCareFeature ?  	<Grid item className={classes.questionItem}>
									<Typography className={classes.question}>Do you want to resolve this alert in Care as well?</Typography>
									<Grid container justify="space-around" className={classes.buttonGrid}>
										<Grid item>
											<Button
												onClick={() => this.careStatus(Constants.ACTIVITY.CARE_STATUSES.RESOLVED.ID)}
												className={classes.button}
												variant={careStatus === Constants.ACTIVITY.CARE_STATUSES.RESOLVED.ID ? "contained" : "outlined"}
												color={careStatus === Constants.ACTIVITY.CARE_STATUSES.RESOLVED.ID ? "primary" : "default"}>
												Yes
											</Button>
										</Grid>
										<Grid item>
											<Button
												onClick={() => this.careStatus(Constants.ACTIVITY.CARE_STATUSES.SHARED.ID)}
												className={classes.button}
												variant={careStatus === Constants.ACTIVITY.CARE_STATUSES.SHARED.ID ? "contained" : "outlined"}
												color={careStatus === Constants.ACTIVITY.CARE_STATUSES.SHARED.ID ? "primary" : "default"}>
												No
											</Button>
										</Grid>
									</Grid>
								</Grid> : null
							} 

							<Grid item>
								<TextField
									name="note"
									margin="normal"
									placeholder={"Add optional note..."}
									value={comments || ""}
									onChange={this.noteChanged}
									className={classes.noteField}
									InputProps={{
										disableUnderline: true,
										classes: {root: classes.noteFieldRoot}
									}} />
								{hasSuppressFeature ?
									<ValidatorForm
										onSubmit={()=>{}}
										onError={()=>{}}
										className={classes.suppressForm}>
										<Tooltip
											placement="top"
											disableFocusListener
											classes={{tooltip: classes.suppressRateTooltip}}
											title="You can change this at any time by clicking the circular 'Rate' button under the workflow buttons.">
											<LabeledCheckbox
												id="suppressRate"
												name="suppressRate"
												checkboxColor="primary"
												checked={this.state.suppressRate}
												onChange={this.suppressRateClicked}
												checkboxClassName={classes.suppressRateChkBx}
												label="Don't show this again when deleting"
												bottomHelperText="Don't show alert rate dialog when deleting" />
										</Tooltip>
									</ValidatorForm> : null
								}
								<Divider />
								<Grid
									container
									justify="space-between"
									alignItems="center"
									className={classes.buttonGrid}>
									<Grid item>
										{!smaller ?
											<Button onClick={closeHandler}>
												Cancel
											</Button> : null
										}
									</Grid>
									<Grid item>
										<Grid
											container
											justify="flex-end"
											alignItems="center">
											<Grid item className={classes.noThxBtnItem}>
												{nextStepHandler ?
													<Button
														color="primary"
														onClick={this.nextStep}>
														Skip Rating
													</Button> : null
												}
											</Grid>
											<Grid item>
												<Button
													color="primary"
													variant="contained"
													className={classes.saveBtn}
													disabled={valuable == null}
													onClick={this.saveClicked}>
													Rate Alert
												</Button>
											</Grid>
										</Grid>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</React.Fragment>
				</RootRef>
			);

		return (
			<ResponsiveDialog
				open={open}
				maxWidth="xs"
				title="Rate Alert"
				content={content}
				hasCancel={!smaller}
				onEntering={this.onEntering}
				closeHandler={closeHandler}
				dlgClasses={{paper: classes.dlgPaper}}
				titleClassName={showSubtitle ? classes.dlgTitle : ""} />
		);
	}
}

RateAlertDialog.propTypes = {
	classes: PropTypes.object.isRequired,
	closeHandler: PropTypes.func.isRequired,
	nextStepHandler: PropTypes.func,
	open: PropTypes.bool,
	rating: PropTypes.object,
	rateHandler: PropTypes.func.isRequired,
	width: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
	showSubtitle: PropTypes.bool,
	suppressRate: PropTypes.number,
	hasCareFeature: PropTypes.bool,
	activityId: PropTypes.number,
	careStatusHandler: PropTypes.func,
	hasSuppressFeature: PropTypes.bool,
	suppressRateHandler: PropTypes.func
};

export default withStyles(styles)(withWidth()(RateAlertDialog));
